import React from 'react';
import { MessageCircle } from 'lucide-react';

export const FloatingWhatsApp = () => {
  return (
    <a
      href="https://wa.me/41767836186"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-green-500 hover:bg-green-400 rounded-full flex items-center justify-center shadow-2xl shadow-green-500/40 transition-all hover:scale-110"
      data-testid="floating-whatsapp-btn"
      aria-label="Contacter sur WhatsApp"
    >
      <MessageCircle className="w-8 h-8 text-white" />
      <span className="absolute inset-0 rounded-full bg-green-500/30 animate-ping"></span>
    </a>
  );
};
